import InputGroup2 from '../components/InputGroup2';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const MembersCount = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>교인 현황</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-12 col-sm-4 col-md-4">
            <InputGroup2
              title={'교인세대수'} //
              value={reportMxData?.members_family}
              setReportMxData={setReportMxData}
              reportColumnName={'members_family'}
              disabled={isReadOnly}
              unit={'세대'}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup2
              title={'교인수'} //
              value={reportMxData?.members}
              setReportMxData={setReportMxData}
              reportColumnName={'members'}
              disabled={isReadOnly}
              unit={'명'}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup2
              title={'안교생수'} //
              value={reportMxData?.members_school}
              setReportMxData={setReportMxData}
              reportColumnName={'members_school'}
              disabled={isReadOnly}
              unit={'명'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembersCount;
